import React from 'react';

import {useTranslation} from 'react-i18next';

import {Loader, LoadingSubtitle, ModalContainerCentered} from './styled';

export const LoaderDoted = () => {
    const {t} = useTranslation();
    return (
        <ModalContainerCentered>
            <LoadingSubtitle>
                {t('pages.profile.billing.invoiceGenerating.loadingSubtitle')}
            </LoadingSubtitle>
            <Loader>
                <img src={'/extra/circle.webp'} alt="Loader" />
            </Loader>
        </ModalContainerCentered>
    );
};
